import { ProductVariant } from '@/models/ProductVariant';
import { PurchaseOrderItem, PurchaseOrderItemKeyInfo } from '@/models/PurchaseOrderItem';
import { thumbnailTransformer } from '@/support/ThumbnailTransformer';
import { Component, PropSync, Vue } from 'vue-property-decorator';

@Component<EditPurchaseOrderItemCard>({})
export default class EditPurchaseOrderItemCard extends Vue {

  // #region @PropSyncs

  @PropSync('purchaseOrderItemSync')
  protected purchaseOrderItem!: null | PurchaseOrderItem;

  @PropSync('isFormValidSync')
  protected isFormValid!: boolean;

  // #endregion

  // #region @Props
  // #endregion

  // #region @Refs
  // #endregion

  // #region Props

  protected PurchaseOrderItemKeyInfo = PurchaseOrderItemKeyInfo;

  // #endregion

  // #region Plugin props
  // #endregion

  // #region Lifecycle hooks / Init
  // #endregion

  // #region Handlers
  // #endregion

  // #region Helpers
  // #endregion

  // #region API Requests
  // #endregion

  // #region Getters & Setters

  protected get description(): string {
    if (!this.purchaseOrderItem) { return ''; }

    if (!this.purchaseOrderItem.product_variant || typeof this.purchaseOrderItem.product_variant !== 'object') { return ''; }

    const productVariant: ProductVariant = this.purchaseOrderItem.product_variant;

    const productName: string = productVariant.name ? productVariant.name : '';
    const productEan: string = '';
    const productSku: string = productVariant.sku ? productVariant.sku : '';
    const productSupplierStyle: string = productVariant.supplier_style_name ? productVariant.supplier_style_name : '';

    return `<div>
  ${productName ? `<span><strong>${productName}</strong></span>` : ''}
  ${productEan ? `<span>${productEan}</span>` : ''}
  ${productSku ? `<span class='text-grey'>${productSku}</span>` : ''}
  ${productSupplierStyle ? `<span class='text-light-grey'>${productSupplierStyle}</span>` : ''}
</div>`;
  }

  protected get image(): string {
    if (!this.purchaseOrderItem) { return ''; }

    if (!this.purchaseOrderItem.product_variant || typeof this.purchaseOrderItem.product_variant !== 'object') { return ''; }
    const productVariant: ProductVariant = this.purchaseOrderItem.product_variant;

    if (!productVariant.image_url) { return ''; }
    const productImage: string = productVariant.image_url;

    return thumbnailTransformer(productImage);
  }

  protected get gap(): string {
    return ['sm', 'lg', 'xl'].includes(this.$vuetify.breakpoint.name)
      ? '16'
      : '0';
  }

  // #endregion

  // #region @Watchers
  // #endregion
}
